import logo from './logo.svg';
import './App.css';
import MainNavigator from './MainNavigator/MainNavigator';

function App() {
  return (
    <MainNavigator />
  );
}

export default App;
